import { type PlaceItem } from '../ProfilePlaces/types';

export interface CollaborationGraphContainerFormat {
	id: string;
	entityType: string;
	containerType: string;
	containerDetails?: {
		id: string;
		key: string;
		name: string;
		url: string;
		iconUrl: string;
	} | null;
}

const getType = ({ containerType }: CollaborationGraphContainerFormat): 'project' | 'space' => {
	switch (containerType) {
		case 'jiraProject':
			return 'project';
		case 'confluenceSpace':
			return 'space';
		default:
			return 'project';
	}
};

export function toContainersViewFormat(nodes: CollaborationGraphContainerFormat[]): PlaceItem[] {
	if (!nodes) {
		return [];
	}
	return nodes
		.filter((container) => !!container)
		.filter(
			({ containerType = '' }) =>
				containerType === 'jiraProject' || containerType === 'confluenceSpace',
		)
		.map((node) => {
			if (!node || !node.containerDetails) {
				return;
			}

			return {
				id: node?.id,
				name: node?.containerDetails?.name,
				icon: node?.containerDetails?.iconUrl,
				type: getType(node),
				path: node?.containerDetails?.url,
				hasLoaded: true,
			};
		})
		.filter((it) => !!it) as PlaceItem[];
}
